import {instagramActionsTypes} from "../constants/ActionTypes";

const initialState = {
  isSynchronizing: false
};

const instagram = (state = initialState, action) => {
  switch (action.type) {
    case (instagramActionsTypes.SYNCHRONIZE_POSTS_LOADING):
      return {
        ...state,
        isSynchronizing: action.state
      };
  }

  return state;
};

export default instagram;



// WEBPACK FOOTER //
// ./reducers/instagram.reducers.js